import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCMaggie extends NPC {
    constructor() {
        super(definitions.NPC_ID.MAGGIE);

        this.collisionRadius = 6;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -14;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_maggie_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(5, -5));
        this.animateIdle(0.35);
    }
}